<style lang="scss">

.el-submenu{
  &.is-opened{
    .el-submenu__title {
      background: rgba(19,72,157,0.1) !important;
      color: #014492;
      font-weight: bold;
    }
  }
}
</style>
<style scoped lang="scss">
#leftMenu{
  background: #F9F9F9;
}
.el-menu-vertical-demo{
  &.el-menu{
    background: #F9F9F9 !important;
    .el-submenu__title{
      font-size: 18px !important;
    }
    .el-menu-item{
      font-size: 16px !important;
      background: #F9F9F9!important;
    }
  }
}
.breadCrumb{
  font-size: 20px;
  font-weight: bolder;
  color: #0b489b;
  padding-left: 20px;
  margin-bottom: 20px;
}
.goodsList{
  width: 100%;
  li{
    width: 50%;
    padding-bottom: 20px;
    padding-left: 20px;
    .singleLineTitle{
      max-width: 280px;
      overflow: hidden;
      text-overflow: ellipsis; //文本溢出显示省略号
      white-space: nowrap; //文本不会换行
    }
    .descSingleLineTitle{
      max-width: 380px;
      overflow: hidden;
      text-overflow: ellipsis; //文本溢出显示省略号
      white-space: nowrap; //文本不会换行
    }
    .price{
      color: #FF2E2E;
      margin-left: 10px;
      min-width: 130px;
      text-align: right;
      font-size: 24px;
      font-weight: bold;
    }
    .bottom{
      margin-top: 20px;
      font-size: 16px;
      color: #909090;
    }
  }
}
.goodsImage{
  width: 100%;
  height: 261px;
}
.el-menu{
  border-right: 0;
  background: #F9F9F9!important;
}

.cons{
  display: none;
}
.banner-molecular{
  height: 600px;
  overflow: hidden;
  img{
    position: relative;
    margin-top: -600px;
    z-index: -10;
  }
  .info{

    .container{
      height: 600px;
      h1{
        padding-top: 153px;
        color: #FFF;
        font-size: 60px;
      }
      .description{
        font-size: 18px;
        color: #FFF;
        margin-top: 34px;
        line-height: 34px;
      }


    }
  }
}
.wrap-products{
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }

  @media
  screen and (max-width: 375px) and (min-width: 374px),
  screen and (max-width: 414px) and (min-width: 413px),
  screen and (max-width: 640px) and (min-width: 600px),
  screen and (min-width: 300px) and (max-width:400px)
  {
    .container100{
      margin-bottom: 10px!important;
    }
    .wrap-tec .container2 {
      width: 100% !important;
      line-height: 25px;
      /* margin-bottom: 0!important; */
      font-size: 14px !important;
    }
    .service_chan{
      justify-content:flex-start!important;
    }
  }

  //当前选中子级的样式
  .is-active{
  }
  .page2{
    display: none;
  }
  .page1{
    display: block;
  }
  .record{
    padding:15px;
    border: 1px solid #E4E6EA;
    margin-top: 20px;
    .title{
      padding:10px 0;
      font-weight: bold;
      border-bottom: 1px solid #E4E6EA;
    }
    li{
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-top: 15px;
      .te{
        word-break:break-word;
      }
      img{
        width:40px;
        height: 40px;
        margin-right: 10px;
      }
    }
  }
  .product-lists{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    .el-select{
      width: fit-content!important;
    }
    li{
      padding:30px;
      border: 1px solid #E4E6EA;
      width:calc(50% - 10px);
    }
    .top{
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    .title{
      font-size: 16px;
      font-weight: bold;
      margin:3px 0 11px;
    }
    .price{
      font-size: 24px;
      font-weight: bold;
      color: #014492;
      margin-top: 10px;
      small{
        font-size: 14px;
        font-weight: normal;
      }
    }
    .img-box{
      position: relative;
      margin-right: 20px;
      width:106px;
      height:106px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        display: block;
        font-size: 0;
        width:100%;
        height:100%;
      }
    }
    .rank{
      position: absolute;
      bottom:0;
      left:0;
      padding:2px 8px;
      color: #fff;
      font-size: 12px;
      background: rgba(0,0,0,.5);
    }
    label{
      display: block;
      margin-bottom: 5px;
    }
    .el-select{
      width:90px;
    }
    .el-input-number{
      width:90px;
    }
    .num{
      margin-left: 10px;
      margin-right: 25px;
    }
    .bot{
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-top: 10px;
    }
    .el-badge{
      margin-left: 10px;
    }
    .el-badge__content{
      padding:0 5px;
    }
    .add-chart{
      width:40px;
      display: block;
      font-size: 0;
    }
  }
}
.products{
  .el-menu-item{
    span{
      width:100%;
      display: block;
    }
  }
  .el-menu-item.is-active{
    font-weight: bold;
    background: none;
  }
}
  .strengths{
    display: flex;
    margin-top: 30px;
    li{
      flex:1;
      text-align: center;
      border-right: 1px solid #eee;
      padding:0 40px;
      &:last-child{
        border: 0;
      }
      h4{
        font-size: 18px;
        margin-bottom: 10px;
        color:#014492;
      }
    }
  }
  .service_chan{
    margin-bottom: 20px;
    display: flex;
    overflow: auto;
    justify-content: space-around;
    li{
      width: 190px;
      height: 188px;
      //margin-right:100px;
      background: url("../../assets/img/产品及服务/fuwu.jpg") no-repeat!important;
      background-size: auto!important;
      .img{
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
        padding-top: 20px;
        padding-bottom: 20px;
      }
      p{
        font-size: 16px;
        color:#4e4e4e;
        margin-bottom: 10px;
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
      }
      .liaojie{
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
        color:#959595;
        cursor: pointer;
      }
    }
    li:hover{
      background: url("../../assets/img/产品及服务/fuwu1.jpg") no-repeat!important;
      background-size: auto!important;
      p{
        color: #fff;
      }
      .liaojie{
        color: #fff;
      }
    }
    li:last-child{
      margin-right: 0;
    }
  }
  .download{
    display: flex;
    flex-wrap: wrap;
    border-left: 1px solid #E4E6EA;
    li{
      width:50%;
      padding:20px 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #E4E6EA;
      border-right: 1px solid #E4E6EA;
      font-size: 16px;
      cursor: pointer;
      &:nth-of-type(1){
        border-top: 1px solid #E4E6EA;
      }
      &:nth-of-type(2){
        border-top: 1px solid #E4E6EA;
      }
      &:hover{
        color:#014492;
      }
    }
    .btn-primary{
      font-size: 14px;
      span{
        margin-right: 7px;
      }
    }
    .mr41{
      display: block;
    }
    .mr42{
      display: none;
    }
  }
  .table{
    tr{
      td:first-child{
        background: #F6FAFD;
      }
    }
  }
  .c-title small{
    margin-top: 10px;
  }
  .required{
    font-size: 24px;
    background: none!important;
    margin-left: 0!important;
  }
  .desc{
    font-size: 16px;
  }
  .effect-lists{
    //display: block!important;
    justify-content: space-between;
    flex-wrap:wrap;
    overflow: auto;
  }
  .effect-lists1 li{
    width: 261px;
    height: 262px;
  }
  .compose-type1{
    padding-bottom: 50px;
    //background: url("../../assets/img/产品及服务/基因检测/bg.png") no-repeat;
    //background-size: 100% 100%;
  }
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
.wrap /deep/ .tc{text-align: left!important;}
.wrap /deep/ .tc span{padding-left: 40px;}
</style>
<template>
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <div class="banner-molecular" v-if="!$route.meta.invisible" :style="{background:'url('+require('@/assets/img/设备及原料/分子试剂/banner.png')+')'}">

      <div class="info">
        <div class="container">
          <h1>分子试剂</h1>
          <!--          <h2 class="mt10">16S / 18S / ITS amplicon sequencing（二代）</h2>-->
          <div class="description">
            <p class="">擎科生物目前拥有10大产品线，400多种自主品牌产品分子生物学试剂产品，涵盖核酸提取/纯化/保存系列、反转录系列、荧光定量系列、PCR系列、核酸电泳系列、克隆系列、感受态系列、蛋白系列、培养基系列、高通量提取与纯化系列等分子生物学试验所用的各种试剂。</p>
            <p class="" :style="{marginTop: '34px'}">擎科生物分子试剂生产实验中心位于湖北省鄂州市，其总面积超4500平方米，是集研发中心、十万级GMP自动化生产车间、多温区仓储中心于一体的综合基地。从生产源头到最终交付，保证产品稳定性。始终专注产品品质与创新，坚持为基础科研工作和工业科研生产提供丰富、高品质的试剂产品和专业优质服务。</p>
          </div>
        </div>
<!--        <img src="@/assets/img/设备及原料/分子试剂/banner.png" class="img-fluid">-->
      </div>
    </div>
    <section v-if="!$route.meta.invisible">
<!--      <div class="container container100" style="margin-bottom: 50px;margin-top: 20px;">-->
<!--      &lt;!&ndash; <p class="desc">擎科生物目前拥有8大产品线，100多种自主品牌产品分子生物学试剂产品，年复合增长率超过30%，涵盖<a href="/equipment/Molecular_reagent?id=1&name=核酸提取%2F纯化" style="color:#014492;font-weight:bold;">核酸提取/纯化/保存、</a><a href="/equipment/Molecular_reagent?id=3&name=反转录系列" style="color:#014492;font-weight:bold;">反转录系列、</a><a href="/equipment/Molecular_reagent?id=30&name=荧光定量系列" style="color:#014492;font-weight:bold;">荧光定量系列、</a><a href="/equipment/Molecular_reagent?id=2&name=PCR系列" style="color:#014492;font-weight:bold;">PCR系列、</a><a href="/equipment/Molecular_reagent?id=5&name=电泳系列" style="color:#014492;font-weight:bold;">核酸电泳系列、</a><a href="/equipment/Molecular_reagent?id=4&name=克隆系列" style="color:#014492;font-weight:bold;">克隆系列、</a><a href="/equipment/Molecular_reagent?id=31&name=感受态系列" style="color:#014492;font-weight:bold;">感受态系列、</a><a href="/equipment/Molecular_reagent?id=6&name=蛋白系列" style="color:#014492;font-weight:bold;">蛋白系列</a>等分子生物学试验所用的各种试剂。擎科生物始终专注产品品质与创新，坚持为基础科研工作和工业科研生产提供丰富、高品质的试剂产品和专业优质服务。</p> &ndash;&gt;-->

<!--      </div>-->

      <div class="compose-type1" style="margin-top: 0px;">
        <div class="container con">
          <div class="wrap wrap-products">
            <section class="container products">
              <div class="flex flex-justify-space-between">
                <div :style="{
                  width: '272px'
                }">
                  <el-menu
                    :unique-opened="true"
                    :default-active="defaultActive"
                    :default-openeds="openIds"
                    class="el-menu-vertical-demo"
                    :style="menuHeight"
                    id="leftMenu"
                    @open="openSubMenu"
                  >
                    <div :style="{padding: '20px'}">
                      <div :style="{fontWeight: 'bold', color: $route.query.id ? '' : '#0b489b', borderBottom: '1px solid #E4E6EA', paddingBottom: '20px', fontSize: '18px', cursor: 'pointer'}" @click="getGoodsUrl(null)">分子试剂</div>
                    </div>
                    <template v-for="item in categories">
                      <template  v-if="item.children.length > 0">
                        <el-submenu :index="'submenu_'+item.id" :key="item.id">
                          <template slot="title">
                            <span :id="'menu_id_'+item.id" :style="{fontSize: '16px'}">{{item.name}}</span>
                          </template>
                          <template v-for="v in item.children" >
                            <el-menu-item class="menu-item tc" @click="getGoodsUrl(v.name, v.id,item.name)" :key="'menu_' + v.id" :index="'menu_' + v.id">
                              <span slot="title" :id="'menu_id_'+v.id">{{v.name}}</span>
                            </el-menu-item>
                          </template>
                        </el-submenu>
                      </template>
                      <template v-else>
                        <el-menu-item :index="'menu_'+item.id" :key="item.id" level="menu_level_1">
                          <template slot="title">
                            <span :id="'menu_id_'+item.id" @click="getGoodsUrl(item.name, item.id)">{{item.name}}</span>
                          </template>
                        </el-menu-item>
                      </template>
                    </template>
                  </el-menu>
                </div>
                <div :style="{width:'928px'}">
                  <div class="breadCrumb">
                    <span>{{this.breadArr.join(' > ')}}</span>
                  </div>
                  <ul class=" goodsList flex flex-justify-start flex-wrap">
                    <li v-for="(item, index) in goodsLists" :key="index">
                      <el-card :body-style="{ padding: '0px' }" shadow="hover">

                        <el-image :src="item.mainImgUrl" class="goodsImage" :fit="'contain'" :style="{cursor:'pointer'}"  @click="goToProduct(item.skus)"></el-image>
                        <div style="padding: 14px;">
                          <div class="flex flex-justify-start">
                            <div :style="{width: '30px'}">
                              <img v-if="item.goodsTag === 'NEW'" src="@/assets/images/new.png" :style="{width: '28px'}">
                              <img v-if="item.goodsTag === 'HOT'" src="@/assets/images/hot.png" :style="{width: '28px'}">
                            </div>
                            <div>
                              <div class="flex flex-justify-space-between" :style="{width: '370px'}">
                                <h3 class="singleLineTitle" :style="{cursor:'pointer', fontSize:'20px'}" @click="goToProduct(item.skus)">{{item.name}}</h3>
                                <div class="price">¥ {{item.skuDetails ? item.skuDetails.priceY : 0}}</div>
                              </div>
                              <div class="bottom clearfix">
                                <div class="flex">
                                  <span>货号：{{item.skus}}</span>
                                  <span :style="{marginLeft: '10px'}">规格：{{item.skuDetails ? item.skuDetails.spec : ''}}</span>
                                </div>
                                <div class="flex" :style="{marginTop: '10px'}">
                                  <div class="descSingleLineTitle">产品简介：{{item.title}}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </el-card>
                    </li>
                  </ul>
                  <div class="page tr page1" v-show="total > 0">
                    <el-pagination
                      background
                      layout="prev, pager, next"
                      :total="total"
                      @size-change="changeSizes"
                      @current-change="changePage">
                    </el-pagination>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div class="container cons">
          <div class="wrap wrap-products">
            <section class="container2 products">
              <el-row :gutter="40">
                <el-col :span="24">
                  <el-menu
                    :default-active="defaultActive"
                    :default-openeds="openIds"
                    :unique-opened="true"
                    class="el-menu-vertical-demo">
                    <el-menu-item index="分子试剂" @click="getGoodsUrl(null)">分子试剂</el-menu-item>
                    <template v-for="item in categories">
                      <template  v-if="item.children.length > 0">
                        <el-submenu :index="'submenu_'+item.id" :key="item.id">
                          <template slot="title">
                            <span @click="getGoodsUrl(item.name, item.id)">{{item.name}}{{item.id}}</span>
                          </template>
                          <template v-for="v in item.children" >
                            <el-menu-item class="menu-item" @click="getGoodsUrl(v.name, v.id)" :key="'menu_' + v.id" :index="'menu_' + v.id">
                              <span slot="title">{{v.name}}{{v.id}}</span>
                            </el-menu-item>
                          </template>
                        </el-submenu>
                      </template>
                      <template v-else>
                        <el-menu-item :index="'menu_'+item.id" :key="item.id">
                          <template slot="title">
                            <span @click="getGoodsUrl(item.name, item.id)">{{item.name}}</span>
                          </template>
                        </el-menu-item>
                      </template>
                    </template>
                  </el-menu>
<!--                  <div class="record">-->
<!--                    <div class="title">浏览记录</div>-->
<!--                    <ul>-->
<!--                      <li v-for="item in records" :key="item.id" @click="$router.push(`/products/details/${item.id}`)">-->
<!--                        &lt;!&ndash;                        <img :src="item.mainImgUrl">&ndash;&gt;-->
<!--                        <div class="info">-->
<!--                          <div class="te">{{item.name}}</div>-->
<!--                          &lt;!&ndash;                          <p class="text-primary fb">¥ {{item.price | amount}}</p>&ndash;&gt;-->
<!--                        </div>-->
<!--                      </li>-->
<!--                    </ul>-->
<!--                  </div>-->
                </el-col>
                <el-col :span="24" style="margin-top: 20px;">
                  <div class="text-primary fb">{{total}}件商品</div>
                  <ul class="product-lists">
                    <li v-for="(item, index) in goodsLists" :key="item.id">
                      <div class="text-primary fb" style="padding-bottom: 10px;">{{item.category.name}}</div>
                      <div class="top" @click="$router.push(`/products/details/${item.id}`)">
                        <!--                        <div class="img-box"><img :src="item.mainImgUrl">-->
                        <!--                          <span class="rank">{{item.skuDetails.code}}</span>-->
                        <!--                        </div>-->
                        <div class="info">
                          <div class="title text-ellipsis">{{item.name}}
                            <span style="color: #014492;margin-left: 10px;">
                              {{item.skus}}
                            </span>
                            <span v-if="item.skus1">
                              /{{item.skus1}}
                            </span>
                          </div>
                          <!--                          <p class="text-gray9 text-ellipsis2" style="height:40px;line-height: 20px;">{{item.code}}</p>-->
                          <!--                          <p class="price">¥ {{item.skuDetails.price | amount}}</p>-->
                        </div>
                      </div>
                      <!--                      <div class="bot">-->
                      <!--                        <div class="specs">-->
                      <!--                          <label>规格：</label>-->
                      <!--                          <el-select v-model="item.curSku" placeholder="请选择规格" @change="changeSku($event, index)">-->
                      <!--                            <el-option-->
                      <!--                              v-for="(itx, index) in item.skus"-->
                      <!--                              :key="index"-->
                      <!--                              :label="itx.spec"-->
                      <!--                              :value="itx.id">-->
                      <!--                            </el-option>-->
                      <!--                          </el-select>-->
                      <!--                        </div>-->
                      <!--                        <div class="num">-->
                      <!--                          <label>数量：</label>-->
                      <!--                          <el-input-number v-model="item.skuNum" controls-position="right" :min="1" :max="100"></el-input-number>-->
                      <!--                        </div>-->
                      <!--                        <el-button class="btn mr42" size="mini" type="primary" @click="toBuy(item)">立即购买</el-button>-->
                      <!--                        <el-button class="btn mr41"  type="primary" @click="toBuy(item)">立即购买</el-button>-->
                      <!--                        <el-badge :value="item.num" class="item" :hidden="item.num===0 || item.specs === ''">-->
                      <!--                          <img src="@/assets/images/icon_chart2.png" class="add-chart pointer" @click="toChart(item)">-->
                      <!--                        </el-badge>-->
                      <!--                      </div>-->
                    </li>
                  </ul>
                  <div class="page tr" v-show="total > 0">
                    <el-pagination
                      layout="prev, pager, next"
                      :total="total"
                      small
                      @current-change="changePage">
                    </el-pagination>
                  </div>
                </el-col>
              </el-row>
            </section>
          </div>
        </div>
      </div>
        <div class="c-title">资源中心<small>Resource center</small></div>
        <div class="container mt30 mb30">
          <ul class="download">
            <li v-for="item in resourcesLists" :key="item.id">
              {{item.name}}
              <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
            </li>
          </ul>
        </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <div class="con">
          <ul class="effect-lists service_chan">
            <li v-for="(item, index) in gene1" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/tk1_${item.img}${currentType===index ? '' : '_active'}.png`" >
              <p style="margin-top: 10px;">{{item.name}}</p>
              <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
            </li>
          </ul>
        </div>
        <div class="cons">
          <ul class="service_chan">
            <li v-for="(item, index) in gene1" :key="index" class="pointer"   @click="$router.push(item.ref)">
              <div class="gene_img2"><img :src="`/static/img/tk1_${item.img}${currentType===index ? '' : '_active'}.png`" style="width: 55px;height: 55px;"></div>
              <p style="margin-top: 10px;">{{item.name}}</p>
              <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import bread from "@/components/bread"
import _ from 'lodash'
import { resourceColumns, resourceDownloads,productsCarousels, productCategories, productGoods, browsingHistories, createCarts, updateCarts, carts } from '@/services/api.index'
export default {
  components: {
    bread,
  },
  data () {
    return {
      currentType: -1,
      gene1: [
        {name: '基因合成',img: '1', ref: '/tec/gen_compose'},
        {name: '引物合成', img: '2',ref: '/tec/compose1'},
        {name: '基因检测',img: '3', ref: '/products/Gene'},
        {name: '常规分子项目',img: '5', ref: '/products/Conventional_molecular_project'},
      ],
      page1: 0,
      total1: 0,
      resourcesLists: [],
      categoryId: '',
      specs: '',
      categories: [],
      bannerLists: [],
      goodsLists: [],
      records: [],
      total: 0,
      cartLists: [],
      bannerHeight: '',
      page: 0,
      size: 6,
      defaultActive: '',
      openIds: [],
      menuHeight: {
        height: '950px',
        overflow: 'auto'
      },
      categoriesOriginal: [],
      breadArr: []
    }
  },
  created () {
    this.getResourceColumns()
    // this.getBanners()
    this.getCategories()
    this.getRecords()
  },
  mounted() {
    this.defaultActive = 'menu_' + this.$route.query.id
    // document.querySelector('#menu_id_' + this.$route.query.id).scrollIntoView(true)

  },

  methods: {
    goToProduct(skuCode){
      window.open(process.env.SHOP_URL + 'product/sku?skuCode=' + encodeURI(skuCode), '_blank')
    },
    getBreadCrumb(id) {
      console.info(this.categoriesOriginal)
      console.info(id)
      const currentCategory = _.filter(this.categoriesOriginal, {id: id/1})
      console.info('CURRENT CATEGORY', currentCategory)

      if (currentCategory.length > 0 && currentCategory[0].parent){
        this.breadArr = [currentCategory[0].parent.name, currentCategory[0].name]
      } else {
        this.breadArr = [currentCategory[0] ? currentCategory[0].name : '分子试剂']
      }
    },
    openSubMenu(idx) {
      console.info('MENU OPENED', idx)
      this.$router.push('/molecular-reagent?id=' + idx.split('_')[1])
    },
    scrollMenuToView(menuId) {
      setTimeout(()=>{
        this.scrollMenuToViewHandle(menuId)
      }, 500)
    },
    scrollMenuToViewHandle(menuId) {
      this.getBreadCrumb(menuId)
      if (!menuId){
        return false
      }
      let element = document.querySelector('#menu_id_' + menuId)
      const menuDom = document.querySelector('#leftMenu')
      const menuTop = ((element.parentElement.getAttribute('class') === 'el-submenu__title') ||
      (element.parentElement.getAttribute('level') === 'menu_level_1'))
        ?
        element.parentElement.offsetTop :
        element.parentElement.parentElement.parentElement.offsetTop
      if (
        (element.parentElement.getAttribute('class') === 'el-submenu__title') ||
        (element.parentElement.getAttribute('level') === 'menu_level_1')
      ){
        this.openIds = ['submenu_' + menuId]
      }
      console.info('MENU TOP', menuTop)
      menuDom.scrollTo({
        left: 0,
        top: menuTop - 220,
        behavior: 'smooth'
      })
    },
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total1 = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total1 = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage1 (value) {
      this.page1 = value - 1
      this.getResourcesLists(this.categoryId)
    },
    // // banner轮播
    // getBanners () {
    //   productsCarousels().then(res => {
    //     this.bannerLists = res.data
    //   })
    // },
    // toCarouselLink (item) {
    //   this.baseMethods.carouselsAction(item)
    // },
    // 获取分子分类菜单
    getCategories () {
      productCategories().then(res => {
        this.categoriesOriginal = res.data
        let categories = []
        let childrenLists = []
        res.data.map(item => {
          if (item.level === 1) {
            categories.push(item)
          } else {
            childrenLists.push(item)
          }
        })
        categories.map(item => {
          item.children = []
          childrenLists.map(itx => {
            if (itx.level === 2 && itx.parent && itx.parent.id === item.id) {
              item.children.push(itx)
            }
          })
        })
        this.categories = categories
        this.getCurrentProduct()
        this.scrollMenuToView(this.$route.query.id)
      })
    },
    // 商品查询
    getGoods (id) {
      const { page, size } = this
      productGoods(id, page, size).then(res => {
        res.data.map(item => {
          console.info('ITEM GETTED.', item)
          item.skuDetails = item.skus[0]
          item.skus = item.skus.length > 0 ? item.skus[0].code : ''
          item.skus1 = item.skus.length > 0 ? item.skus[0].code : ''
          item.num = 0
          // item.skuNum = 0
        })
        this.goodsLists = res.data
        this.goodsLists.sort((a,b)=>a.category.name.localeCompare(b.category.name))
        this.total = this.baseMethods.getTotal(res)
        // if (this.baseMethods.getLocalObj('userInfo')) {
        //   this.getCartInfo()
        // }
      })
    },
    getGoodsUrl (name, id,parentName) {
      id = id || ''
      if(name=='培养基系列'||parentName=='培养基系列'){
        window.open(process.env.SHOP_URL + 'product/list/846?productTagsId=&brandId=154&promotionId=&orderType=&promotionPluginId=&startPrice=&endPrice=','_blank');
        return;
      }
      this.$router.push(`/molecular-reagent?id=${id}&name=${name}`)
    },
    // 商品浏览记录
    getRecords () {
      browsingHistories().then(res => {
        this.records = res.data
      })
    },
    // 获取购物车信息
    // getCartInfo () {
    //   carts().then(res => {
    //     this.cartLists = res.data
    //     this.goodsLists.map(itx => {
    //       itx.num = 0
    //     })
    //     res.data.map(item => {
    //       this.goodsLists.map(itx => {
    //         if (itx.id === item.sku.goods.id) {
    //           itx.num += item.quantity
    //         }
    //       })
    //     })
    //   })
    // },
    // changeSku (value, index) {
    //   const currentProduct = this.goodsLists[index].skus.filter(item => item.id === value)
    //   this.goodsLists[index].skuNum = 0
    //   this.goodsLists[index].skuDetails = currentProduct[0]
    //   this.goodsLists[index].curSku = value
    // },
    getCurrentProduct () {
      const queryName = this.$route.query.name
      const currentPro = this.categories.filter(item => item.name === queryName && item.canShow)
      let id = this.$route.query.id
      if (currentPro.length === 0 && !id) {
        this.defaultActive = '全部商品'
      }
      if (!id && currentPro.length > 0) {
        id = currentPro[0].id
      }
      this.getGoods(id)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      const id = this.$route.query.id
      this.getGoods(id)
    },
    changeSizes (value) {
      this.size = value
      const id = this.$route.query.id
      this.getGoods(id)
    }
  },
  computed:{
    // goodsLists: function() {
    //   return this.goodsLists.sort((a,b)=>a.category.name.localeCompare(b.category.name,"zh"));//升序
    // }
  },
  watch: {
    $route (to) {
      console.info(to.query.id)
      this.defaultActive = 'menu_' + to.query.id
      this.page = 0
      this.getCurrentProduct()
      this.scrollMenuToView(to.query.id)
      // document.querySelector('#menu_id_' + to.query.id)[0].scrollIntoView()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/molecular_reagents/Molecular_reagent.vue